import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import moment from 'moment';
import DownloadIcon from '../../../assets/icons/download-icon';
import { QueryParameterKeys } from '../../../globals/paramter';
import { AppState } from '../../../store';
import { enqueueSnackbarAction } from '../../../store/snackbar/actions';
import { exportTransactionsActions } from '../../../store/transactions/actions';
import theme from '../../../globals/theme';
import { testIsOrbcomm } from '../../../globals/utils';

const ExportTransactions = () => {
  const dispatch = useDispatch();
  const recordCount = useSelector((state: AppState) => state.transactions.count);
  const location = useLocation();
  const parameters: URLSearchParams = new URLSearchParams(location.search);
  const startTime = parameters.get(QueryParameterKeys.startTime) || undefined;
  const endTime = parameters.get(QueryParameterKeys.endTime) || undefined;
  const transactionTypes = parameters.get(QueryParameterKeys.category) || '';
  const fileTypeIdFilters = parameters.get(QueryParameterKeys.fileTypeIdFilters) || undefined;
  const excludeFileTypeIdFilters = parameters.get(QueryParameterKeys.excludeFileTypeIdFilters) || undefined;
  const vimsData = parameters.get(QueryParameterKeys.vimsData) || undefined;
  const deviceType = useSelector((state: AppState) => state.search.selectedEntity?.deviceType);
  const isOrbcommDevice = testIsOrbcomm(deviceType);
  const selectedEntity = useSelector((state: AppState) => state.search.selectedEntity);
  const exportable = useSelector((state: AppState) => state.transactions.exportable);
  const deviceKey = selectedEntity?.deviceKey;
  const telematicsAssetId = selectedEntity?.telematicsAssetId;
  const timeFrame = parameters.get(QueryParameterKeys.timeFrame) || '';

  const exportTransactionsHandler = () => {
    if (deviceKey && recordCount > 0 && recordCount < 10000) {
      dispatch(
        exportTransactionsActions({
          startTime,
          endTime,
          deviceKey: vimsData === "true" ? undefined : deviceKey,
          telematicsAssetId: vimsData === "true" ? telematicsAssetId : undefined,
          fileTypeIdFilters,
          excludeFileTypeIdFilters,
          vimsData,
          transactionTypes,
        }),
      );
    } else if (recordCount === 0) {
      dispatch(
        enqueueSnackbarAction({
          message: 'No Transactions to export with given filter criteria!',
          options: {
            variant: 'warning',
          },
        }),
      );
    } else if (recordCount >= 10000) {
      dispatch(
        enqueueSnackbarAction({
          message:
            'Transactions limit too high, please refine transactions using the filters to select fewer than 10,000 transactions',
          options: { variant: 'error' },
        }),
      );
    }
  };

  if (!isOrbcommDevice)
    return (
      <Tooltip title="Export Transactions" enterDelay={600}>
        <IconButton
          disabled={!exportable}
          onClick={exportTransactionsHandler}
          id="exportButton"
          size="large">
          <DownloadIcon fill={exportable ? theme.palette.grey[600] : undefined} />
        </IconButton>
      </Tooltip>
    );

  return null;
};

export default ExportTransactions;
